/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.deconnexion.ts
 *
 * « Se déconnecter » en bas de la page « Plus » (2026-10-07, demande de
 * Mika). Fusionné dans fr.ts. Mikael - chef de projet - 2026-10-07
 */
export const messagesDeconnexionFr: Record<string, string> = {
  'deconnexion.bouton': 'Se déconnecter',
  'deconnexion.question': 'Se déconnecter de cet appareil ?',
  'deconnexion.confirmer': 'Oui, me déconnecter',
  'deconnexion.annuler': 'Annuler',
};
